<h1 class="display-5 text-primary font-weight-bold mt-4">Badge Administration</h1>
<p><a [routerLink]="['/more/badges']">Back to badges</a></p>
<div *ngIf="canAward" class="card"><div class="card-body">
  <h3 class="text-primary">Award Badges</h3>
  <p *ngIf="awardError" role="alert" class="alert alert-danger">{{awardError}}</p>
  <p *ngIf="awardSuccess" role="status" class="alert alert-success">{{awardSuccess}}</p>
  <form (ngSubmit)="onConfirmAwardClick()">
    <fieldset [disabled]="isAwarding">
      <label for="selectBadge">Badge</label>
      <ng-select [(ngModel)]="selectedBadge" [items]="badgeRefs$ | async" [multiple]="false" [disabled]="isAwarding" id="selectBadge" name="selectBadge" placeholder="Choose a badge">
        <ng-template let-item="item" ng-label-tmp>{{localize.badgeName(item)}}</ng-template>
        <ng-template let-item="item" ng-option-tmp>{{localize.badgeName(item)}}</ng-template>
      </ng-select>
      <label for="awardLevel" class="mt-3">Award level</label>
      <input id="awardLevel" name="awardLevel" type="number" min="1" step="1" required class="form-control" [(ngModel)]="awardLevel">
      <label for="selectUsers" class="mt-3">Recipients (up to 50)</label>
      <contributor-drop-down [userOptions]="waihonaUserRefs$ | async" [(ngModel)]="usersToReceiveBadge" [showMultiple]="true" name="selectUsers" id="selectUsers" placeholder="Choose users"></contributor-drop-down>
      <button type="submit" [disabled]="isAwarding" class="btn btn-primary mt-3">{{isAwarding ? 'Awarding…' : 'Award Badges'}}</button>
      <button type="button" [disabled]="isAwarding" (click)="resetAward()" class="btn btn-light mt-3">Cancel</button>
    </fieldset>
  </form>
</div></div>
<div *ngIf="canManage" class="card mt-4"><div class="card-body">
  <h3 class="text-primary">Badge Administrator Roles</h3>
  <p>Badge administrators can create, edit, and award badges across Waihona. Only Waihona administrators can grant or revoke this role.</p>
  <p>After a role change, affected users should sign out and back in. Revocation also removes legacy badgeEditor access.</p>
  <p *ngIf="adminError" role="alert" class="alert alert-danger">{{adminError}}</p>
  <p *ngIf="adminSuccess" role="status" class="alert alert-success">{{adminSuccess}}</p>
  <p *ngIf="isLoadingAdmins" role="status">Loading administrators…</p>
  <button type="button" class="btn btn-light" [disabled]="isLoadingAdmins || isManaging" (click)="loadAdmins()">Refresh list</button>
  <ul><li *ngFor="let user of badgeAdmins" class="my-2">
    {{user.altFirstName || user.firstName}} {{user.lastName}}
    <button type="button" class="btn btn-sm btn-outline-danger ml-2" [disabled]="isManaging" (click)="setAdmins([user], false)">Revoke badge role</button>
  </li></ul>
  <p *ngIf="!isLoadingAdmins && !badgeAdmins.length">No badge administrators assigned.</p>
  <form (ngSubmit)="setAdmins(usersToGrant, true)">
    <label for="selectBadgeAdmins">Grant badge administrator access (up to 50 users)</label>
    <contributor-drop-down [(ngModel)]="usersToGrant" [userOptions]="waihonaUserRefs$ | async" [showMultiple]="true" id="selectBadgeAdmins" name="selectBadgeAdmins" placeholder="Choose users"></contributor-drop-down>
    <button type="submit" class="btn btn-primary mt-3" [disabled]="isManaging || !usersToGrant.length">{{isManaging ? 'Saving…' : 'Grant Badge Administrator Role'}}</button>
  </form>
</div></div>
